import { css} from '@emotion/css';
import { onCleanup } from 'solid-js';
import { onMount } from 'solid-js';
import { Portal } from 'solid-js/web';


const overlayStyle = () => css({
	width: '100vw',
	height: '100vh',
	position: 'fixed',
	top: 0,
	left: 0,
	zIndex: 10,
});

const backgroundStyle = () => css({
	width: '100%',
	height: '100%',
	backgroundColor: 'rgba(0, 0, 0, 0.2)'
});

const foregroundStyle = () => css({
	position: 'fixed',
	top: '50%',
	left: '50%',
	transform: 'translateX(-50%) translateY(-50%)'
});

const bodyStyle = () => css({
	width: 'fit-content',
	display: 'flex',
	flexDirection: 'column'
});

const topBarStyle = () => css({
	display: 'flex',
	marginBottom: '1em',
	border: 'solid 1px black',
	borderRadius: '2em',
	justifyContent: 'flex-end'
});

const closeStyle = () => css({
	fontWeight: 'bold',
	fontSize: '2em',
	width: '1.4em',
	height: '1.4em',
	borderRadius: '1em',
	border: 'solid 3px black',
	userSelect: 'none',
	cursor: 'pointer',
	margin: 5
});


//XXX could almost be a general-purpose popup, but for the colour patch in the bar at the top...

export function ColourPickerPopup(P)
{
	/* Prevent underlay from scrolling */
	onMount(() => {
		document.body.style.overflowY = 'hidden';

		onCleanup(() => {
			document.body.style.overflowY = '';
		});
	});


	/* Note if needed: Portal can take a node other than <body> as an argument */
	return (
		<Portal>
			<div class={overlayStyle()}> 
				<div class={backgroundStyle()} />
				<div class={foregroundStyle()}>
					<div class={bodyStyle()}>
						<div class={topBarStyle()} style={{'background-color':P.value}} >
							<button class={closeStyle()} onClick={P.close}>×</button>
						</div>

						{P.children}
					</div>
				</div>
			</div>
		</Portal>
	);
}
